<template>
<div class="chapter">
<div class="inner_page">
<p class="hang-indent">I <span class="smallcaps">STRUCK</span> the board, and cry’d, No more. I will abroad. What? shall I ever sigh and pine?</p>
<p class="hang-indent-b">My lines and life are free; free as the road, Loose as the winde, as large as store. Shall I be still in suit? Have I no harvest but a thorn To let me blood, and not restore</p>
<p class="hang-indent-b">What I have lost with cordiall fruit? Sure there was wine Before my sighs did drie it: there was corn Before my tears did drown it. Is the yeare onely lost to me? Have I no bayes to crown it?</p>
<p class="hang-indent-b">No flowers, no garlands gay? all blasted? All wasted? Not so, my heart: but there is fruit, And thou hast hands. Recover all thy sigh-blown age</p>
<p class="hang-indent-b">On double pleasures: leave thy cold dispute</p>
<p class="hang-indent-b">Of what is fit, and not; forsake thy cage, Thy rope of sands,</p>
<p class="hang-indent-b">Which pettie thoughts have made, and made to thee Good cable, to enforce and draw, And be thy law, While thou didst wink and wouldst not see. Away; take heed: I will abroad.</p>
<p class="hang-indent-b">Call in thy deaths head there: tie up thy fears. He that forbears To suit and serve his need, Deserves his load.</p>
<p class="hang-indent-b">But as I rav’d and grew more fierce and wilde At every word, Me thought I heard one calling, <i>Childe:</i> And I reply’d, <i>My Lord</i>.</p>
<p class="right1"><span>GEORGE HERBERT</span></p>
<p class="right2"><span>(1593–1633)</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?0a5d6641